import Raven from 'raven-js';
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Router from '../Router';
import asyncComponent from '../AsyncComponent';
import Notifications from '../Notifications';
import BrowserSupport from '../BrowserSupport';

const IndexRoute = asyncComponent(() => import('routes/Home'));
const DashboardRoute = asyncComponent(() => import('routes/Dashboard'));
const ActivateAccount = asyncComponent(() => import('routes/ActivateAccount'));
const ResetPassword = asyncComponent(() => import('routes/ResetPassword'));
const NotFound = asyncComponent(() => import('routes/NotFound'));
const WereldGrachtenRoute = asyncComponent(() => import('routes/WereldGrachtenMap'));

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  componentDidMount () {
    this.props.initialize();
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1200);
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  render () {
    if (this.state.loading) {
      return null;
    }

    return (
      <div style={{ width: '100%', height: '100%' }}>
        <Router>
          <Switch>
            <Route path="/" exact component={IndexRoute} />
            <Route path="/dashboard" component={DashboardRoute} />
            <Route path="/activate" render={props => <ActivateAccount {...props} />} />
            <Route path="/reset" render={props => <ResetPassword {...props} />} />
            <Route path="/wereldgrachten" component={WereldGrachtenRoute} />
            <Route component={NotFound}/>
          </Switch>
        </Router>
        <Notifications />
        <BrowserSupport />
      </div>
    );
  }
}

App.propTypes = {
  initialize: PropTypes.func.isRequired
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js